import type { TableHTMLAttributes } from "react";
import { cx } from "./cx";

export interface TableWrapProps extends TableHTMLAttributes<HTMLTableElement> {
  /** Extra class for the outer `.table-wrap` scroll container. */
  wrapClassName?: string;
}

/**
 * The POC's horizontally scrolling table container. `className` (e.g.
 * "comparison-table") lands on the inner `<table>`; children are the
 * caller's `<thead>`/`<tbody>`.
 */
export function TableWrap({ wrapClassName, className, children, ...rest }: TableWrapProps) {
  return (
    <div className={cx("table-wrap", wrapClassName)}>
      <table className={className} {...rest}>
        {children}
      </table>
    </div>
  );
}
